'use client';

import { XPToast } from '@/components/gamification/XPToast';
import { BadgeUnlockModal } from '@/components/gamification/BadgeUnlockModal';
import { LevelUpModal } from '@/components/gamification/LevelUpModal';
import badgesData from '@/data/badges.json';
import type { Badge } from '@/types';

export function GameOverlays() {
  const badges = badgesData as Badge[];

  return (
    <>
      <XPToast />
      <BadgeUnlockModal badges={badges} />
      <LevelUpModal />
    </>
  );
}
